export default function isMcSymbol(symbol: string) {
    return symbol.indexOf("TT") >= 0;
}

export function isBonusWild(symbol: string) {
    return symbol.indexOf("WW_BN") >= 0;
}

export function isBlankMcSymbol(symbol: string) {
    return isMcSymbol(symbol) && symbol.length === 2;
}
